
import { GoogleGenAI, Type } from "@google/genai";
import { Product } from '../types';

export const arDiscoveryService = {
  analyzeSpatialFit: async (base64Frame: string, productName: string) => {
    try {
      const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
      const response = await ai.models.generateContent({
        model: 'gemini-3-flash-preview',
        contents: {
          parts: [
            { inlineData: { mimeType: 'image/jpeg', data: base64Frame } },
            { text: `Spatial AI Analysis: Look at this camera frame. We want to place a "${productName}" in this environment.
              Identify:
              1. A flat surface location (x, y coordinates in percent from top-left, 0-100).
              2. Best placement scale (0.1 to 2.0).
              3. Confidence score (0-100).
              4. A snappy, tech-guru comment about the environment.
              
              Format: JSON { "x": number, "y": number, "scale": number, "confidence": number, "comment": string }` 
            }
          ]
        },
        config: {
          responseMimeType: "application/json",
          responseSchema: {
            type: Type.OBJECT,
            properties: {
              x: { type: Type.NUMBER },
              y: { type: Type.NUMBER },
              scale: { type: Type.NUMBER },
              confidence: { type: Type.NUMBER },
              comment: { type: Type.STRING }
            },
            required: ["x", "y", "scale", "confidence", "comment"]
          }
        }
      });
      return JSON.parse(response.text);
    } catch (e) {
      console.error("AR Spatial Error:", e);
      return null;
    }
  }
};
